import { useRef, memo } from 'react';
import { getThemeColor, legacyTheme } from 'styles/theme';
import { IconProps } from '../icon.props';
import { IconPresets } from '../icon.presets';

const SvgSearch = memo((iconProps: IconProps) => {
  const ref = useRef();
  const {
    color: colorProp,
    height,
    strokeWidth,
    width,
    ...props
  } = { ...IconPresets, ...iconProps, ref };
  const color = getThemeColor(colorProp);
  return (
    <svg
      fill={color}
      fillRule="evenodd"
      height="1em"
      opacity={0.7}
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16 9A7 7 0 112 9a7 7 0 1114 0m4.586 13l-5.35-5.35 1.414-1.414 5.35 5.35z" />
    </svg>
  );
});
export default SvgSearch;
